// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const raticate_alola: PokeData = {
  "id": 10092,
  "name": "raticate-alola",
  "height": 7,
  "weight": 255,
  "base_experience": 145,
  "types": [
    PokeType.DARK,
    PokeType.NORMAL
  ],
  "api_moves": [
    "swords-dance",
    "tackle",
    "double-edge",
    "tail-whip",
    "bite",
    "counter",
    "quick-attack",
    "focus-energy",
    "fury-swipes",
    "hyper-fang",
    "super-fang",
    "scary-face",
    "pursuit",
    "crunch",
    "endeavor",
    "assurance",
    "sucker-punch"
  ],
  "moves": [
    "tackle",
    "bite",
    "quick-attack",
    "scary-face",
    "pursuit",
    "crunch",
    "tri-attack",
    "dark-pulse",
    "purification",
    "snarl",
    "leer",
    "body-slam",
    "dark-bargain"
  ],
  "evolution_chain": {
    "id": 7,
    "item": null,
    "species": [
      {
        "name": "rattata",
        "order": 19,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "raticate",
        "order": 20,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 19,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 135,
    "speed": 138,
    "ability_power": 127
  },
  "stat_changes": [],
  "catch_rate": 127,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "alola"
} as const;
